/** Formatting helpers for the Delivery Runs console. */

/** Turn a SCREAMING_SNAKE_CASE enum value into a Title Case label
 *  (`PARTIAL_DELIVERY` → `Partial Delivery`) for a human-friendly fallback. */
export function humanizeEnum(value: string): string {
  return value
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/** Compact duration label from seconds (`93` → `1m 33s`, `null` → `—`). */
export function formatDurationSeconds(seconds: number | null | undefined): string {
  if (seconds == null || !Number.isFinite(seconds)) return '—';
  const total = Math.max(0, Math.round(seconds));
  if (total < 60) return `${String(total)}s`;
  const mins = Math.floor(total / 60);
  const secs = total % 60;
  if (mins < 60) return secs ? `${String(mins)}m ${String(secs)}s` : `${String(mins)}m`;
  const hours = Math.floor(mins / 60);
  const remMins = mins % 60;
  return remMins ? `${String(hours)}h ${String(remMins)}m` : `${String(hours)}h`;
}

/** Turn a camelCase or snake_case object key into a readable label
 *  (`coveragePct` → `Coverage Pct`, `row_count` → `Row Count`) for shape-agnostic fact lists. */
export function humanizeKey(key: string): string {
  return key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_.-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
